import { makeStyles, useTheme } from '@material-ui/core/styles';

type ImageStyleProps = {
	placeholderColor?: string;
};

export const Theme = useTheme;
export const useStyles = makeStyles(theme => {
	return {
		imageRoot: {
			position: 'relative',
			height: '100%',
			display: 'flex',
			flexDirection: 'column'
		},
		image: {
			objectFit: 'cover',
			objectPosition: 'center center',
			width: '100%',
			height: '100%'
		},
		linearOverlay: {
			position: 'absolute',
			width: '100%',
			height: '100%',
			background: 'linear-gradient(202.42deg, rgba(0, 0, 0, 0.12) -0.5%, rgba(0, 0, 0, 0) 24.05%)'
		},
		imagePlaceholder: {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			backgroundColor: '#DEAB86',
			zIndex: 2
		},
		previewMediaPlaceholder: {
			position: 'absolute',
			width: '100%',
			height: '100%',
			boxSizing: 'border-box',
			transition: 'all .5s linear',
			opacity: 1,
			pointerEvents: 'none',
			zIndex: 1,
			backgroundColor: (props: ImageStyleProps) => props.placeholderColor || '#EBE8E6'
		},
		previewMediaPlaceholderHidden: {
			opacity: 0
		}
	};
});
